import { MapUiTheme } from '../../common';
import { padding, margin } from '../../common/theme/utils';

export const cardTheme = {
  defaultStyles: {
    backgroundColor: (theme: MapUiTheme) => theme.colors.white,
    borderWidth: '0px',
    borderRadius: '12px',
    boxShadow: '0 4px 12px 0 rgba(2, 3, 3, 0.16)',
    fontSize: (theme: MapUiTheme) => theme.fontSize.base,
  },
  xs: {
    ...padding(
      (theme: MapUiTheme) => theme.spacing['1'],
      (theme: MapUiTheme) => theme.spacing['3']
    ),
    ...margin('0px', (theme: MapUiTheme) => theme.spacing['4']),
  },
  sm: {
    ...padding(
      (theme: MapUiTheme) => theme.spacing['2'],
      (theme: MapUiTheme) => theme.spacing['3']
    ),
    ...margin('0px', (theme: MapUiTheme) => theme.spacing['4']),
  },
  md: {
    ...padding(
      (theme: MapUiTheme) => theme.spacing['4'],
      (theme: MapUiTheme) => theme.spacing['4']
    ),
    ...margin('0px', (theme: MapUiTheme) => theme.spacing['4']),
  },
  lg: {
    ...padding(
      (theme: MapUiTheme) => theme.spacing['6'],
      (theme: MapUiTheme) => theme.spacing['6']
    ),
    ...margin('0px', (theme: MapUiTheme) => theme.spacing['4']),
  },
  xl: {
    ...padding(
      (theme: MapUiTheme) => theme.spacing['8'],
      (theme: MapUiTheme) => theme.spacing['8']
    ),
    ...margin('0px', (theme: MapUiTheme) => theme.spacing['4']),
  },
};
